module.exports = {
  apiKey: "AIzaSyCyuvuihlJBevsoGM_390cgbrdaP8bMrvY",
  authDomain: "fbn3-5a44f.firebaseapp.com",
  projectId: "fbn3-5a44f",
  storageBucket: "fbn3-5a44f.appspot.com",
  messagingSenderId: "666162946951",
  appId: "1:666162946951:web:fedeebdf672496d9896922",
  measurementId: "G-85X9CJHSP6",
}
